import { useAppSelector } from "src/store/hooks";

type Properties = {
    label: string;
    onClick: () => void;
    isHidden?: boolean;
    disabled?: boolean;
    type?: 'submit' | 'reset' | 'button';
    className?: string;
};

const PrimaryButton = (props: Properties) => {
    const config = useAppSelector(state => state.globalState.config);

    if (props.isHidden) {
        return <></>;
    }

    return (
        <button 
            onClick={props.onClick} 
            className={`primary ${props.className || ''}`}
            disabled={props.disabled}
            type={props.type || 'button'}
            style={{ backgroundColor: config?.themeColor || '#acbcbc' }}
        >
            {props.label}
        </button>
    );
};
export default PrimaryButton;
